import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { handleActions } from 'redux-actions';
import type { Action } from '../actions';
import type { QuestionsType } from './index';
import { updateFollowUp } from '../utils/compat';
export const defaultState: QuestionsType = {
  'cebf8f04-d650-4f74-a2a5-77038433e731': {
    id: 'cebf8f04-d650-4f74-a2a5-77038433e731',
    question: 'This First Level',
    type: 'select',
    limit: 1,
    tags: [],
    answers: [{
      answer: '1',
      note: 'none'
    }, {
      answer: '2',
      note: 'none'
    }, {
      answer: '3',
      note: 'none'
    }, {
      answer: '4 (virtual)',
      note: 'none',
      virtual: true
    }, {
      answer: '5 (virtual)',
      note: 'none',
      virtual: true
    }],
    followUps: [{
      conditions: [[{
        id: 'cebf8f04-d650-4f74-a2a5-77038433e731',
        answer: '1'
      }]],
      questionId: '1885dd4c-f2f0-4e5c-bfdb-2c6d2f1ca7ad'
    }, {
      conditions: [[{
        id: 'cebf8f04-d650-4f74-a2a5-77038433e731',
        answer: '2'
      }]],
      questionId: '52ad988b-d3f7-4d2c-a508-e239ea2dea71'
    }]
  },
  '1885dd4c-f2f0-4e5c-bfdb-2c6d2f1ca7ad': {
    id: '1885dd4c-f2f0-4e5c-bfdb-2c6d2f1ca7ad',
    question: 'Second Level',
    type: 'select',
    limit: 1,
    tags: [],
    answers: [{
      answer: '11',
      note: 'none'
    }, {
      answer: '12',
      note: 'none'
    }, {
      answer: '13',
      note: 'none'
    }],
    followUps: [{
      conditions: [[{
        id: '1885dd4c-f2f0-4e5c-bfdb-2c6d2f1ca7ad',
        answer: '11'
      }]],
      questionId: '004129aa-4ac5-4526-a12c-e8a431a34f72'
    }, {
      conditions: [[{
        id: '1885dd4c-f2f0-4e5c-bfdb-2c6d2f1ca7ad',
        answer: '12'
      }]],
      questionId: '045ac62b-bdca-4c94-a599-9080dbba6e56'
    }]
  },
  '004129aa-4ac5-4526-a12c-e8a431a34f72': {
    id: '004129aa-4ac5-4526-a12c-e8a431a34f72',
    question: 'Third Lvl',
    type: 'select',
    limit: 1,
    tags: [],
    answers: [{
      answer: '311',
      note: 'none'
    }, {
      answer: '312',
      note: 'none'
    }, {
      answer: '313',
      note: 'none'
    }],
    followUps: []
  },
  '045ac62b-bdca-4c94-a599-9080dbba6e56': {
    id: '045ac62b-bdca-4c94-a599-9080dbba6e56',
    question: 'Another 3 level',
    type: 'select',
    limit: 1,
    tags: [],
    answers: [{
      answer: '321',
      note: 'none'
    }, {
      answer: '322',
      note: 'none'
    }, {
      answer: '323',
      note: 'none'
    }],
    followUps: []
  },
  '52ad988b-d3f7-4d2c-a508-e239ea2dea71': {
    id: '52ad988b-d3f7-4d2c-a508-e239ea2dea71',
    question: 'Another Lvl2',
    type: 'select',
    limit: 1,
    tags: [],
    answers: [{
      answer: '21',
      note: 'none'
    }, {
      answer: '22',
      note: 'none'
    }, {
      answer: '23',
      note: 'none'
    }],
    followUps: [{
      conditions: [[{
        id: '52ad988b-d3f7-4d2c-a508-e239ea2dea71',
        answer: '22'
      }]],
      questionId: 'a93a7a8b-128a-492a-ad01-fc14a9de670c'
    }]
  },
  'a93a7a8b-128a-492a-ad01-fc14a9de670c': {
    id: 'a93a7a8b-128a-492a-ad01-fc14a9de670c',
    question: 'Another level 3',
    type: 'select',
    limit: 1,
    tags: [],
    answers: [{
      answer: '321',
      note: 'none'
    }, {
      answer: '322',
      note: 'none'
    }, {
      answer: '326',
      note: 'none'
    }],
    followUps: []
  }
};
export default handleActions<QuestionsType, Action>({
  // @ts-expect-error todo(ts-migration) TS2322 Type '(state: QuestionsType, action: Action) => { [x: string]: QuestionType; }' is not assignable to type 'ReducerMapValue<QuestionsType, Action>'.
  removeQuestion: (state: QuestionsType, action: Action) => {
    const questionId = get(action, 'payload.questionId');
    const nextState = {
      ...state
    };
    delete nextState[questionId];
    return nextState;
  },
  // @ts-expect-error todo(ts-migration) TS2322 Type '(state: QuestionsType, action: Action) => QuestionsType' is not assignable to type 'ReducerMapValue<QuestionsType, Action>'.
  addQuestion: (state: QuestionsType, action: Action) => {
    const parentId = get(action, 'payload.questionId');
    const newQuestion = get(action, 'payload.newQuestion');
    if (parentId) {
      const parentQuestion = cloneDeep(get(state, parentId));
      if (parentQuestion) {
        if (!parentQuestion.followUps) {
          parentQuestion.followUps = [];
        }
        // adding new Question to parent question
        parentQuestion.followUps.push({
          conditions: [],
          questionId: newQuestion.id
        });
        // adding followup question
        const nextState = {
          ...state,
          [newQuestion.id]: newQuestion,
          [parentQuestion.id]: {
            ...parentQuestion
          }
        };
        return nextState;
      }
    } else {
      // adding top level question
      return {
        ...state,
        [newQuestion.id]: newQuestion
      };
    }
    return state;
  },
  // @ts-expect-error todo(ts-migration) TS2322 Type '(state: QuestionsType, action: Action) => QuestionsType' is not assignable to type 'ReducerMapValue<QuestionsType, Action>'.
  addConditionalQuestion: (state: QuestionsType, action: Action) => {
    const parentId = get(action, 'payload.questionId');
    const followUpIdx = get(action, 'payload.followUpIdx');
    const newQuestion = get(action, 'payload.newQuestion');
    if (parentId) {
      const parentQuestion = cloneDeep(get(state, parentId));
      if (parentQuestion) {
        let followUp = get(parentQuestion, ['followUps', followUpIdx]);
        // backward compat
        // @ts-expect-error todo(ts-migration) TS2345 Argument of type '{ conditions: ConditionsType; questionId?: string; questionIds?: string[]; }' is not assignable to parameter of type 'FollowUpType'.
        followUp = updateFollowUp(followUp);
        const newFollowUps = [...parentQuestion.followUps];
        newFollowUps[followUpIdx] = {
          ...followUp,
          // @ts-expect-error todo(ts-migration) TS2488 Type 'string[] | undefined' must have a '[Symbol.iterator]()' method that returns an iterator.
          questionIds: [...followUp.questionIds, newQuestion.id]
        };
        const nextState = {
          ...state,
          [newQuestion.id]: newQuestion,
          [parentQuestion.id]: {
            ...parentQuestion,
            followUps: newFollowUps
          }
        };
        return nextState;
      }
    } else {
      // adding top level question
      return {
        ...state,
        [newQuestion.id]: newQuestion
      };
    }
    return state;
  },
  // @ts-expect-error todo(ts-migration) TS2322 Type '(state: QuestionsType, action: Action) => {}' is not assignable to type 'ReducerMapValue<QuestionsType, Action>'.
  updateQuestion: (state: QuestionsType, action: Action) => {
    const question = get(action, 'payload.question');
    const questionId = get(question, 'id');
    return {
      ...state,
      [questionId]: question
    };
  }
}, {});